import { render, staticRenderFns } from "./HealthYN.vue?vue&type=template&id=3472434c"
import script from "./HealthYN.vue?vue&type=script&lang=js"
export * from "./HealthYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports